const ORDER_DETAILS = "ORDER_DETAILS";
const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
const ORDER_DETAILS_FAILURE = "ORDER_DETAILS_FAILURE";
const CLEAR_ORDER_DETAILS = "CLEAR_ORDER_DETAILS";
const GO_BACK = "GO_BACK";

const OrderDetailsSymbols = {
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAILURE,
  ORDER_DETAILS,
  CLEAR_ORDER_DETAILS,
  GO_BACK
};

export default OrderDetailsSymbols;
